module.exports = __webpack_public_path__ + "img/EElogo.9e4a9eb5.png";